
import fetchApi from "../fetch-api";
import { getQueryPath } from "ui-io/get-query-path";
import { DealByStagesIO } from "../deal-io";

type CompanyByIdPropsT = {
  date?: string;
  industry?: string;
  limit?: number;
};

export const getDealByStage = (props: CompanyByIdPropsT) => {
  let params = props;
  const { industry,date } = props;
  const queryPath = getQueryPath({...params});
  return {
    queryKey: ["DEAL_BY_STAGE", queryPath],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        headers:{method: 'GET'},
        pathname: `/deal-by-stage?${ queryPath}`,
        codec: DealByStagesIO,
      }),
  };
};
